import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { closeServerBeforeRemoveEpic } from './_epics/closeServerBeforeRemove.epic';
import { closeServerSidebarEpic } from './_epics/closeServerSidebar.epic';
import { reloadServerListEpic } from './_epics/reloadServerList.epic';
import { reloadServerDetailsEpic } from './_epics/reloadServerDetails.epic';

export const controllerServerEpic = safeCombineEpics(
  closeServerBeforeRemoveEpic,
  closeServerSidebarEpic,
  reloadServerListEpic,
  reloadServerDetailsEpic,
);
